import { SyncStorage } from 'jotai/vanilla/utils/atomWithStorage'

export const stringStorage: SyncStorage<string | null> = {
  getItem: (key, initialValue) => {
    const v = localStorage.getItem(key)
    return v === null ? initialValue : v
  },
  setItem: (key, newValue) => {
    if (newValue == null) localStorage.removeItem(key)
    else localStorage.setItem(key, newValue)
  },
  removeItem: (key) => {
    localStorage.removeItem(key)
  },
  subscribe: (key, set) => {
    const handler = (e: StorageEvent) => {
      if (e.storageArea === localStorage && e.key === key) {
        set(e.newValue)
      }
    }
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  },
}
